<main class="container-fluid">
  <article class="row row bg-white shadow mb-3 mt-3 ml-0 mr-0">
    <section class="col-12 p-4 mb-5">

      <div class="d-flex justify-content-between">
        <div>
          <img src="../../../../../assets/icons/solicitud.png" class="d-inline-block img-responsive mr-3" alt="">
          <label class="h5">Reporte general</label>
        </div>
        <p>
          <button type="button" class="btn btn-outline-success mr-3" (click)="isExportar = !isExportar"
            [attr.aria-expanded]="!isExportar">Exportar</button>
          <button type="button" class="btn btn-outline-primary" (click)="isCollapsed = !isCollapsed"
            [attr.aria-expanded]="!isCollapsed" aria-controls="filtros">
            Ver filtros
          </button>
        </p>
      </div>

      <div id="exportar-form" *ngIf="!isExportar">
        <div class="card mb-3">
          <div class="card-body">
            <form [formGroup]="exportarForm" (submit)="submit()">
              <div class="row">
                <div class="col-3 mb-2 input-group-prepend" formArrayName="exportarList"
                  *ngFor="let order of exportarForm.controls.exportarList.controls; let i = index">
                  <div class="input-group-text">
                    <input type="checkbox" [formControlName]="i">
                  </div>
                  <label class="label label-primary medium" for="">{{exportarList[i].name}}</label>
                </div>
                <div class="col-4 mb-2 input-group-prepend">
                  <div class="input-group-text">
                    <input type="checkbox" formControlName="selectAll">
                  </div>
                  <label class="label label-primary medium" for="">Seleccionar/Deseleccionar Todo</label>
                </div>
                <div class="col-2"></div>
                <div class="col-2">
                  <button class="btn btn-success m-auto" type="submit"
                    [disabled]="!exportarForm.valid">Exportar</button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>


      <div id="filtros" [ngbCollapse]="isCollapsed">
        <div class="card mb-3">
          <div class="card-body">
            <form [formGroup]="filtro" (submit)="filtrar()">
              <div class="row">
                <!-- codigo_camara-->
                <div class="col-2 form-group" >
                  <label class="small text-secondary" for="codigo_camara">Cámara de Comercio</label>
                  <select class="form-control form-control-sm" id="codigo_camara" formControlName="codigo_camara">
                    <option class="" value="{{codigoCamara}}" selected="true">
                      Seleccione
                    </option>
                    <option class="" *ngFor="let option of camarasLista; let i = index"
                      value="{{option?.codigo_camara}}" [selected]="false">
                      {{option?.desc_camara}}
                    </option>
                  </select>
                </div>
                <!-- razon_social-->
                <div class="col-2 form-group">
                  <label class="small text-secondary" for="razon_social">Razón Social</label>
                  <input id="razon_social" formControlName="razon_social" type="text" class="form-control form-control-sm">
                </div>
                <!-- numero_identificacion-->
                <div class="col-2 form-group">
                  <label class="small text-secondary" for="numero_identificacion">NIT del propietario</label>
                  <input id="numero_identificacion" formControlName="numero_identificacion" type="text" class="form-control form-control-sm">
                </div>
                <!-- tipo_usuario_id-->
                <div class="col-2 form-group">
                  <label class="small text-secondary" for="tipo_usuario_id">Tipo Usuario</label>
                  <select class="form-control form-control-sm" id="tipo_usuario_id" formControlName="tipo_usuario_id">
                    <option class="" value="" selected="true">
                      Seleccione
                    </option>
                    <option class="" *ngFor="let option of tiposUsuario; let i = index" value="{{option?.id}}"
                      [selected]="false">
                      <!-- Traer las opciones de tipo RNT -->
                      {{option?.descripcion}}
                      <!-- Acá se recorre las opciones de tipo RNT -->
                    </option>
                  </select>
                </div>
                <!-- tipo_solicitud_id-->
                <div class="col-2 form-group">
                  <label class="small text-secondary" for="tipo_solicitud_id">Tipo Solicitud</label>
                  <select class="form-control form-control-sm" id="tipo_solicitud_id" formControlName="tipo_solicitud_id">
                    <option class="" value="" selected="true">
                      Seleccione
                    </option>
                    <option class="" *ngFor="let option of tipoSolicitudLista; let i = index" value="{{option?.tipo_solicitud_id}}"
                      [selected]="false">
                      <!-- Traer las opciones de tipo RNT -->
                      {{option?.descripcion}}
                      <!-- Acá se recorre las opciones de tipo RNT -->
                    </option>
                  </select>
                </div>
                <!-- tipo_rnt_id-->
                <div class="col-2 form-group">
                  <label class="small text-secondary" for="tipo_rnt_id">Tipo RNT</label>
                  <select class="form-control form-control-sm" id="tipo_rnt_id" formControlName="tipo_rnt_id">
                    <option class="" value="" selected="true">
                      Seleccione
                    </option>
                    <option class="" *ngFor="let option of tipoRNT; let i = index" value="{{option?.tipo_rnt_id}}"
                      [selected]="false">
                      <!-- Traer las opciones de tipo RNT -->
                      {{option?.descripcion}}
                      <!-- Acá se recorre las opciones de tipo RNT -->
                    </option>
                  </select>
                </div>
                <!-- codigo_rnt-->
                <div class="col-2 form-group">
                  <label class="small text-secondary" for="codigo_rnt">Número RNT</label>
                  <input id="codigo_rnt" formControlName="codigo_rnt" type="text"
                    class="form-control form-control-sm">
                </div>
                <!-- categoria_id-->
                <div class="col-2 form-group">
                  <label class="small text-secondary" for="categoria_id">Categoría</label>
                  <select class="form-control form-control-sm" id="categoria_id" formControlName="categoria_id"
                        (change)="onSubcategoriaSelect()">
                    <option class="" value="" selected="true">
                      Seleccione
                    </option>
                    <option class="" *ngFor="let option of categoria; let i = index" value="{{option?.categoria_id}}"
                      [selected]="false">
                      {{option?.descripcion}}
                    </option>
                  </select>
                </div>
                <!-- sub_categoria_id-->
                <div class="col-2 form-group">
                  <label class="small text-secondary" for="sub_categoria_id">Subcategoría</label>
                  <select class="form-control form-control-sm" id="sub_categoria_id" formControlName="sub_categoria_id">
                    <option class="" value="" selected="true">
                      Seleccione
                    </option>
                    <option class="" *ngFor="let option of subcategoria; let i = index" value="{{option?.sub_categoria_id}}"
                      [selected]="false">
                      {{option?.descripcion}}
                    </option>
                  </select>
                </div>
                <!-- estado_rnt-->
                <div class="col-2 form-group">
                  <label class="small text-secondary" for="estado_rnt">Estado RNT</label>
                  <select class="form-control form-control-sm" id="estado_rnt" formControlName="estado_rnt">
                    <option class="" value="" selected="true">
                      Seleccione
                    </option>
                    <option class="" *ngFor="let option of estadoRnt; let i = index" value="{{option?.estado_rnt_id}}"
                      [selected]="false">
                      {{option?.descripcion}}
                    </option>
                  </select>
                </div>
                <!-- ultimo_anio_renovado-->
                <div class="col-2 form-group">
                  <label class="small text-secondary" for="ultimo_anio_renovado">Ultimo año renovado</label>
                  <input id="ultimo_anio_renovado" formControlName="ultimo_anio_renovado" type="text"
                    class="form-control form-control-sm" maxlength="4" max="4">
                </div>
                <!--codigo_departamento-->
                <div class="col-2 form-group">
                  <label class="small text-secondary" for="codigo_departamento">Departamento</label>
                  <select class="form-control form-control-sm" id="codigo_departamento" formControlName="codigo_departamento" (change)="onMunicipioSelect()">
                     <option class="" value="" selected="true">
                         Seleccione
                      </option>
                     <option class="" *ngFor="let option of departamento; let i = index"
                         value="{{option?.departamento_id}}" [selected]="false">
                         {{option?.descripcion}}
                     </option>
                  </select>
                </div>
                <!--municipio_id-->
               <div class="col-2 form-group">
                   <label class="small text-secondary" for="municipio_id">Municipio</label>
                   <select class="form-control form-control-sm" id="municipio_id" formControlName="municipio_id">
                      <option class="" value="" selected="true">
                          Seleccione
                       </option>
                      <option class="" *ngFor="let option of municipio; let i = index"
                          value="{{option?.municipio_id}}" [selected]="false">
                          {{option?.descripcion}}
                      </option>
                   </select>
                </div>
                <!--funcionario-->
                <div class="col-2 form-group">
                  <label class="small text-secondary" for="funcionario">Funcionario</label>
                  <input id="funcionario" formControlName="funcionario" type="text"
                    class="form-control form-control-sm">
                </div>
                <!--numero_Radicado-->
                <div class="col-2 form-group">
                  <label class="small text-secondary" for="numero_Radicado">Número Radicado</label>
                  <input id="numero_Radicado" formControlName="numero_Radicado" type="text"
                    class="form-control form-control-sm">
                </div>
                <!--estado_solicitud_id-->
                <div class="col-2 form-group">
                  <label class="small text-secondary" for="estado_solicitud_id">Estado Solicitud</label>
                  <select class="form-control form-control-sm" id="estado_solicitud_id" formControlName="estado_solicitud_id">
                    <option class="" value="" selected="true">
                      Seleccione
                    </option>
                    <option class="" *ngFor="let option of estadoSolicitudLista; let i = index" value="{{option?.estado_solicitud_id}}"
                      [selected]="false">
                      {{option?.descripcion}}
                    </option>
                  </select>
                </div>
                <!--fecha_inscripcion-->
                <div class="col-2 form-group" *ngIf="!OcultarCampos">
                  <label class="text-secondary small">Fecha Inscripción</label>
                  <div class="input-group">
                    <input class="form-control form-control-sm" formControlName="fecha_inscripcion"
                      placeholder="yyyy/mm/dd" ngbDatepicker #fecha_inscripcion="ngbDatepicker">
                    <div class="input-group-append">
                      <button class="btn btn-outline-secondary calendar" (click)="fecha_inscripcion.toggle()"
                        type="button"></button>
                    </div>
                  </div>
                </div>
                
                <!--fecha_renovacion-->
                <div class="col-2 form-group" *ngIf="!OcultarCampos">
                  <label class="text-secondary small">Fecha Renovación</label>
                  <div class="input-group">
                    <input class="form-control form-control-sm" formControlName="fecha_renovacion"
                      placeholder="yyyy/mm/dd" ngbDatepicker #fecha_renovacion="ngbDatepicker">
                    <div class="input-group-append">
                      <button class="btn btn-outline-secondary calendar" (click)="fecha_renovacion.toggle()"
                        type="button"></button>
                    </div>
                  </div>
                </div>
                <!--fecha_radicacion-->
                <div class="col-2 form-group" *ngIf="!OcultarCampos">
                  <label class="text-secondary small">Fecha Radicación</label>
                  <div class="input-group">
                    <input class="form-control form-control-sm" formControlName="fecha_radicacion"
                      placeholder="yyyy/mm/dd" ngbDatepicker #fecha_radicacion="ngbDatepicker">
                    <div class="input-group-append">
                      <button class="btn btn-outline-secondary calendar" (click)="fecha_radicacion.toggle()"
                        type="button"></button>
                    </div>
                  </div>
                </div>
                <!--fecha_ultima_actualizacion-->
                <div class="col-2 form-group" *ngIf="!OcultarCampos">
                  <label class="text-secondary small">Fecha Ultima Actualización</label>
                  <div class="input-group">
                    <input class="form-control form-control-sm" formControlName="fecha_ultima_actualizacion"
                      placeholder="yyyy/mm/dd" ngbDatepicker #fecha_ultima_actualizacion="ngbDatepicker">
                    <div class="input-group-append">
                      <button class="btn btn-outline-secondary calendar" (click)="fecha_ultima_actualizacion.toggle()"
                        type="button"></button>
                    </div>
                  </div>
                </div>
                <!--fecha_inscripcion_desde-->
                <div class="col-2 form-group">
                  <label class="text-secondary small">Fecha Inscripción Inicial</label>
                  <div class="input-group">
                    <input class="form-control form-control-sm" formControlName="fecha_inscripcion_desde"
                      placeholder="yyyy/mm/dd" ngbDatepicker #inicio_expedicion="ngbDatepicker" (dateSelect)="onCheckDateInscripcion($event)">
                    <div class="input-group-append">
                      <button class="btn btn-outline-secondary calendar" (click)="inicio_expedicion.toggle()"
                        type="button"></button>
                    </div>
                  </div>
                </div>
                <!--fecha_inscripcion_hasta-->
                <div class="col-2 form-group">
                  <label class="text-secondary small">Fecha Inscripción Final</label>
                  <div class="input-group">
                    <input class="form-control form-control-sm" formControlName="fecha_inscripcion_hasta"
                      placeholder="yyyy/mm/dd" ngbDatepicker #fecha_inscripcion_hasta="ngbDatepicker"  [minDate]="fecha_inicio_inscripcion" (dateSelect)="onCheckDateInscripcion($event)">
                    <div class="input-group-append">
                      <button class="btn btn-outline-secondary calendar" (click)="fecha_inscripcion_hasta.toggle()"
                        type="button"></button>
                    </div>
                  </div>
                </div>

                <!--fecha_renovacion_desde-->
                <div class="col-2 form-group">
                  <label class="text-secondary small">Fecha Renovación Inicial</label>
                  <div class="input-group">
                    <input class="form-control form-control-sm" formControlName="fecha_renovacion_desde"
                      placeholder="yyyy/mm/dd" ngbDatepicker #fecha_renovacion_desde="ngbDatepicker" (dateSelect)="onCheckDateRenovacion($event)">
                    <div class="input-group-append">
                      <button class="btn btn-outline-secondary calendar" (click)="fecha_renovacion_desde.toggle()"
                        type="button"></button>
                    </div>
                  </div>
                </div>
                <!--fecha_renovacion_hasta-->
                <div class="col-2 form-group">
                  <label class="text-secondary small">Fecha Renovación Final</label>
                  <div class="input-group">
                    <input class="form-control form-control-sm" formControlName="fecha_renovacion_hasta"
                      placeholder="yyyy/mm/dd" ngbDatepicker #fecha_renovacion_hasta="ngbDatepicker"  [minDate]="fecha_inicio_renovacion" (dateSelect)="onCheckDateRenovacion($event)">
                    <div class="input-group-append">
                      <button class="btn btn-outline-secondary calendar" (click)="fecha_renovacion_hasta.toggle()"
                        type="button"></button>
                    </div>
                  </div>
                </div>

                <!--fecha_radicacion_desde-->
                <div class="col-2 form-group">
                  <label class="text-secondary small">Fecha Radicación Inicial</label>
                  <div class="input-group">
                    <input class="form-control form-control-sm" formControlName="fecha_radicacion_desde"
                      placeholder="yyyy/mm/dd" ngbDatepicker #fecha_radicacion_desde="ngbDatepicker" (dateSelect)="onCheckDateRadicacion($event)">
                    <div class="input-group-append">
                      <button class="btn btn-outline-secondary calendar" (click)="fecha_radicacion_desde.toggle()"
                        type="button"></button>
                    </div>
                  </div>
                </div>
                <!--fecha_radicacion_hasta-->
                <div class="col-2 form-group">
                  <label class="text-secondary small">Fecha Radicación Final</label>
                  <div class="input-group">
                    <input class="form-control form-control-sm" formControlName="fecha_radicacion_hasta"
                      placeholder="yyyy/mm/dd" ngbDatepicker #fecha_radicacion_hasta="ngbDatepicker"  [minDate]="fecha_inicio_radicacion" (dateSelect)="onCheckDateRadicacion($event)">
                    <div class="input-group-append">
                      <button class="btn btn-outline-secondary calendar" (click)="fecha_radicacion_hasta.toggle()"
                        type="button"></button>
                    </div>
                  </div>
                </div>

                <!--fecha_ultima_actualizacion_desde-->
                <div class="col-2 form-group">
                  <label class="text-secondary small">Fecha Última Actualización Inicial</label>
                  <div class="input-group">
                    <input class="form-control form-control-sm" formControlName="fecha_ultima_actualizacion_desde"
                      placeholder="yyyy/mm/dd" ngbDatepicker #fecha_ultima_actualizacion_desde="ngbDatepicker" (dateSelect)="onCheckDateUltimaActualizacion($event)">
                    <div class="input-group-append">
                      <button class="btn btn-outline-secondary calendar" (click)="fecha_ultima_actualizacion_desde.toggle()"
                        type="button"></button>
                    </div>
                  </div>
                </div>
                <!--fecha_ultima_actualizacion_hasta-->
                <div class="col-2 form-group">
                  <label class="text-secondary small">Fecha Última Actualización Final</label>
                  <div class="input-group">
                    <input class="form-control form-control-sm" formControlName="fecha_ultima_actualizacion_hasta"
                      placeholder="yyyy/mm/dd" ngbDatepicker #fecha_ultima_actualizacion_hasta="ngbDatepicker"  [minDate]="fecha_inicio_ultima_actualizacion" (dateSelect)="onCheckDateUltimaActualizacion($event)">
                    <div class="input-group-append">
                      <button class="btn btn-outline-secondary calendar" (click)="fecha_ultima_actualizacion_hasta.toggle()"
                        type="button"></button>
                    </div>
                  </div>
                </div>

                <div class="d-flex flex-row">
                  <button type="reset" class="btn btn-outline-primary border-0 m-auto btn-align-vertical"
                    (click)="limpiar()">Limpiar</button>
                  <button class="btn btn-primary m-auto solicitud-btn-principal btn-align-vertical"
                    type="submit">Filtrar</button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>

      <div class="table-responsive">
        <app-tablas [page]="paginaActual" [headers]="headerTabla" [sizeData]="dataTabla.paging.totalItems"
          (paginado)="onPaginado($event)" class="table-responsive">
          <tr *ngFor="let item of dataTabla.items; let i=index" class="small">
            <td>{{item.descripcion_camara}}</td>
            <td>{{item.razon_social}}</td>
            <td>{{item.numero_identificacion}}</td>
            <td>{{item.tipo_usuario}}</td>
            <td>{{item.matricula}}</td>
            <td>{{item.fecha_matricula}}</td>
            <td>{{item.fecha_renovacion_matricula}}</td>
            <td>{{item.tipo_rnt}}</td>
            <td>{{item.numero_rnt}}</td>
            <td>{{item.descripcion_categoria}}</td>
            <td>{{item.descripcion_subcategoria}}</td>
            <td>{{item.actividades_economicas}}</td>
            <td>{{item.actividades_economicas_descripcion}}</td>
            <td>{{item.estado_rnt}}</td>
            <td>{{item.fecha_inscripcion}}</td>
            <td>{{item.fecha_ultima_renovacion}}</td>
            <td>{{item.ultimo_anio_renovado}}</td>
            <td>{{item.descripcion_departamento}}</td>
            <td>{{item.descripcion_municipio}}</td>
            <td>{{item.numero_identificacion_representante_legal}}</td>
            <td>{{item.nombre_representante_legal}}</td>
            <td>{{item.correo_electronico}}</td>
            <td>{{item.correo_electronico_reportado}}</td>
            <td>{{item.direccion_comercial}}</td>
            <td>{{item.descripcion_departamento_notificacion}}</td>
            <td>{{item.descripcion_municipio_notificacion}}</td>
            <td>{{item.direccion_notificacion}}</td>
            <td>{{item.telefono_reportado_1}}</td>
            <td>{{item.telefono_reportado_2}}</td>
            <td>{{item.usuario_funcionario}}</td>
            <td>{{item.numero_radicacion}}</td>
            <td>{{item.tipo_solicitud}}</td>
            <td>{{item.estado_solicitud}}</td>
            <td>{{item.fecha_radicacion}}</td>
            <td>{{item.fecha_ultima_actualizacion}}</td>
            <td>{{item.numero_empleados}}</td>
            <td>{{item.nombre_operador_alojamiento}}</td>
            <td>{{item.cantidad_habitaciones}}</td>
            <td>{{item.cantidad_camas}}</td>
            <td>{{item.numero_matricula_embarcacion}}</td>
            <td>{{item.numero_resolucion_mintransporte}}</td>
            <td>{{item.fecha_resolucion_mintransporte}}</td>
            <td>{{item.tarjeta_profesional_guia}}</td>
            <td>{{item.numero_identificacion_depositario}}</td>
            <td>{{item.nombre_depositario}}</td>
            <td>{{item.correo_electronico_depositario}}</td>
            <td>{{item.nombre_comercial}}</td>
            <td>{{item.url}}</td>
            <td>{{item.nit_arrendatario}}</td>
            <td>{{item.razon_social_arrendatario}}</td>
            <td>{{item.correo_electronico_arrendatario}}</td>
            <td>{{item.numero_telefonico_arrendatario}}</td>
          </tr>
        </app-tablas>
      </div>
    </section>
  </article>
</main>
